import { Button, InputGroup, Icon } from '@blueprintjs/core';
import React, { useEffect, useState } from 'react';
import { useHistory } from "react-router-dom";

import apiAdonis from '../../Services/adonis';
import { NotificacaoInterna } from '../../Services/Notification';
import Logo from '../../Assets/Images/SingIn/Logo.png'

import { Container, Form } from './Style';

const View: React.FC = () => {
    /* #region  Variáveis  */
    const [getCapsLock, setCapsLock] = useState<boolean>(false)
    const [getMostrarSenha, setMostrarSenha] = useState<boolean>(false)
    const [getConfirmaçãoMostrarSenha, setConfirmaçãoMostrarSenha] = useState<boolean>(false)
    const [getNovaSenha, setNovaSenha] = useState<string>("")
    const [getConfirmaçãoNovaSenha, setConfirmaçãoNovaSenha] = useState<string>("")
    const [getLoginEfetuado, setLoginEfetuado] = useState<{ Progresso?: number, Resultado?: boolean }>({ Progresso: undefined, Resultado: undefined });
    const History = useHistory();
    /* #endregion */

    /* #region  Funções  */

    async function ResetarMinhaSenha(): Promise<void> {
        if (!getNovaSenha) {
            NotificacaoInterna.ExibirNotificacao("A nova senha vazia.", "Informe para que seja possível redefinir sua senha.", NotificacaoInterna.TipoDeNotificacao.Alerta);
            return;
        }
        if (!getConfirmaçãoNovaSenha) {
            NotificacaoInterna.ExibirNotificacao("A confirmação da senha vazia.", "Informe para que seja possível redefinir sua senha.", NotificacaoInterna.TipoDeNotificacao.Alerta);
            return;
        }
        if (getNovaSenha !== getConfirmaçãoNovaSenha && getConfirmaçãoNovaSenha != "") {
            NotificacaoInterna.ExibirNotificacao("Suas senhas não correspondem.", "Por favor, digite novamente.", NotificacaoInterna.TipoDeNotificacao.Erro);
            return;
        }

        if (getNovaSenha == getConfirmaçãoNovaSenha) {
            if (await ValidarSenha() == true) {
                try {
                    const urlParams = new URLSearchParams(window.location.search)
                    const token = urlParams.get('token')
                    apiAdonis.put(`/rememberPassword/${token}`, {
                        password: getConfirmaçãoNovaSenha
                    }).then(async results => {
                        NotificacaoInterna.ExibirNotificacao("Senha redefinida.", "Sua senha foi redefinidade com sucesso.", NotificacaoInterna.TipoDeNotificacao.Sucesso).then(() => {
                            setTimeout(() => {
                                History.push("/");
                                window.location.reload();
                            }, 5000);

                        })
                    })
                }
                catch (e) {
                    NotificacaoInterna.ExibirNotificacao("Token Expirado.", "É necessário o reenvio do email.", NotificacaoInterna.TipoDeNotificacao.Erro)
                }
            }
        }
    }

    async function ValidarSenha(): Promise<any> {
        var letrasMaiusculas = /[A-Z]/;
        var letrasMinusculas = /[a-z]/;
        var numeros = /[0-9]/;
        var caracteresEspeciais = /[!|@|#|$|%|^|&|*|(|)|-|_]/;

        if (getNovaSenha.length < 6) {
            NotificacaoInterna.ExibirNotificacao("Senha curta demais.", "Sua senha deve ter no mínimo 6 caracteres.", NotificacaoInterna.TipoDeNotificacao.Alerta)
            return false;
        }

        var auxMaiuscula = 0;
        var auxMinuscula = 0;
        var auxNumero = 0;
        var auxEspecial = 0;

        for (var i = 0; i < getNovaSenha.length; i++) {
            if (letrasMaiusculas.test(getNovaSenha[i]))
                auxMaiuscula++;
            else if (letrasMinusculas.test(getNovaSenha[i]))
                auxMinuscula++;
            else if (numeros.test(getNovaSenha[i]))
                auxNumero++;
            else if (caracteresEspeciais.test(getNovaSenha[i]))
                auxEspecial++;
        }

        if (auxMaiuscula > 0) {
            if (auxMinuscula > 0) {
                if (auxNumero > 0) {
                    if (auxEspecial) {
                        return true;
                    }
                }
            }
        }

        if (auxMaiuscula == 0) {
            NotificacaoInterna.ExibirNotificacao("Sua senha não contém letras maiúsculas.", "Por favor, insira pelo menos uma letra maiúscula.", NotificacaoInterna.TipoDeNotificacao.Alerta)
            return;
        }
        if (auxMinuscula == 0) {
            NotificacaoInterna.ExibirNotificacao("Sua senha não contém letras minúsculas.", "Por favor, insira pelo menos uma letra minúscula.", NotificacaoInterna.TipoDeNotificacao.Alerta)
            return;
        }
        if (auxNumero == 0) {
            NotificacaoInterna.ExibirNotificacao("Sua senha não contém números.", "Por favor, insira pelo menos um número.", NotificacaoInterna.TipoDeNotificacao.Alerta)
            return;
        }
        if (auxEspecial == 0) {
            NotificacaoInterna.ExibirNotificacao("Sua senha não contém caracteres especiais.", "Por favor, insira pelo menos um caracter especial.", NotificacaoInterna.TipoDeNotificacao.Alerta)
            return;
        }
    }
    document.addEventListener('keydown', function (event) {
        setCapsLock(event.getModifierState && event.getModifierState('CapsLock'));
        //console.log( getCapsLock == true ? "Caps Lock ON": "Caps Lock OFF");
    });

    useEffect(() => {
        async function componentDidMount() { }
        componentDidMount();
    }, []);

    return (
        <Container>
            <Form>
                <img src={Logo} alt="Logo One+" width="200px" />
                <h3>Analytics</h3>
                <h1>Redefinição de senha</h1>
                <h6>Preencha os dados abaixo para efetuar a redefinição. </h6>
                <div style={{ display: "flex", flexDirection: "column" }}>
                    <div style={{ display: getCapsLock == true ? "flex" : "none", alignItems: "center" }}>
                        <Icon icon="warning-sign" color="yellow" style={{ position: "absolute", marginLeft: "75px", flex: 1, width: "20px", height: "32px" }} />
                        <h2>CapsLock ativado!</h2>
                    </div>
                    <div style={{ display: "flex", alignItems: "flex-end" }}>
                        <InputGroup id="NovaSenha" placeholder="Digite a nova senha" type={getMostrarSenha ? "text" : "password"} value={getNovaSenha}
                            onChange={async (event: React.FormEvent<HTMLInputElement>) => await setNovaSenha(event.currentTarget.value)} />
                        <Button onClick={() => { setMostrarSenha(!getMostrarSenha) }} icon={getMostrarSenha == true ? "eye-open" : "eye-off"} color="black" style={{ position: "absolute", marginLeft: "256px", flex: 1, background: "transparent", border: "0px solid black", outline: "none", width: "20px", height: "32px", boxShadow: "none" }} />
                    </div>
                    <div style={{ display: "flex", alignItems: "flex-end" }}>
                        <InputGroup id="ConfirmaçãoSenha" placeholder="Confirme a nova senha" type={getConfirmaçãoMostrarSenha ? "text" : "password"} value={getConfirmaçãoNovaSenha}
                            onChange={async (event: React.FormEvent<HTMLInputElement>) => await setConfirmaçãoNovaSenha(event.currentTarget.value)} />
                        <Button onClick={() => { setConfirmaçãoMostrarSenha(!getConfirmaçãoMostrarSenha) }} icon={getConfirmaçãoMostrarSenha == true ? "eye-open" : "eye-off"} color="black" style={{ position: "absolute", marginLeft: "256px", flex: 1, background: "transparent", border: "0px solid black", outline: "none", width: "20px", height: "32px", boxShadow: "none" }} />
                    </div>
                </div>
                <div>
                    <Button type="submit" intent="primary" onClick={ResetarMinhaSenha} id="Submit">Enviar</Button>
                </div>
            </Form>
        </Container>
    );
    /* #endregion */
};

export default View;